import React from 'react';
import Icon from '../Base';
import IconContainer from './style';
const Index = (props) => {
  return <Icon {...props} IconContainer={IconContainer} />;
};

export default Index;
